export default {
  data() {
    return {
      // eslint-disable-next-line
      statusOptions: [
        "Created",
        "Approved"
      ],
      // eslint-disable-next-line
      maintPlanStatusForMaintCallOptions: [
        "Created",
        "Scope",
        "Resource",
        "Plan",
        "Decide",
        "Preparation",
        "Execute"
      ]
    };
  }
};
